
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getService } from "../../app/api";
import { Link, useNavigate } from "react-router-dom";

const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 940,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
    ],
};

const ServiceSlider = () => {
    const [Data, setData] = useState([]);

    useEffect(() => {
        try {
            getService().then((res) => {
                if (res) {
                    setData(res.data.results);
                }
            });
        } catch (err) {
        }
    }, []);

    return (

        <div className="bg-gray-200 py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-3xl text-center mb-4">
                    <h2 className="text-3xl font-bold tracking-tight text-[#003463] sm:text-4xl italic mb-4">
                        Бусад үйлчилгээ
                    </h2>
                    <p className="mt-6 text-lg leading-8 text-gray-600">
                        Бид үндсэн болон өдрийн амралтнаас гадна дараах үйлчилгээг санал
                        болгож байна.
                    </p>
                </div>
                <div>
                    <div>
                        {Data.length <= 3 ?
                            <div className="flex flex-wrap justify-center">

                                {Data.map((service: any) => (
                                    <div key={service.title} className="w-80 items-start justify-center px-3 cursor-pointer">
                                        <Link
                                            to={`/service/${service.id}`}
                                        >
                                            <img
                                                loading="lazy"
                                                className="aspect-[14/13] w-full rounded-2xl object-cover"
                                                src={service.thumb}
                                                alt=""
                                            />
                                        </Link>
                                        <h3 className="mt-3 text-lg font-semibold leading-8 tracking-tight text-[#003463] line-clamp-2">
                                            {service.title}
                                        </h3>
                                        <div className="mt-6">
                                            <Link
                                                to={`/service/${service.id}`}
                                                className="mt-6 rounded-full border-2 border-[#07B2EC] px-5 py-2 text-sm font-semibold text-[#07B2EC] "
                                            >
                                                Дэлгэрэнгүй
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div> :
                            <Slider {...settings}>
                                {Data.map((service: any) => (
                                    <div key={service.title} className="px-10 mb-4">
                                        <Link
                                            to={`/service/${service.id}`}
                                        >
                                            <img
                                                loading="lazy"
                                                className="aspect-[14/13] w-full rounded-2xl object-cover"
                                                src={service.thumb}
                                                alt=""
                                            />
                                        </Link>
                                        <h3 className="mt-3 text-lg font-semibold leading-8 tracking-tight text-[#003463] line-clamp-2">
                                            {service.title}
                                        </h3>
                                        <div className="mt-6">
                                            <Link
                                                to={`/service/${service.id}`}
                                                className="mt-6 rounded-full border-2 border-[#07B2EC] px-5 py-2 text-sm font-semibold text-[#07B2EC] "
                                            >
                                                Дэлгэрэнгүй
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        }
                    </div>
                </div>


            </div>
        </div>
    );
};

export default ServiceSlider;



{/* <div>
{Data.length <= 3 ?
    <div className="flex flex-wrap justify-center">


    </div> :

    <Slider {...settings} >
        {Data.map((service: any) => (
            <div key={service.title} className="px-10 mb-4">
                <Link
                    to={`/service/${service.id}`}
                >
                    <img
                        className="aspect-[14/13] w-full rounded-2xl object-cover"
                        src={service.thumb}
                        alt=""
                    />
                </Link>
                <h3 className="mt-3 text-lg font-semibold leading-8 tracking-tight text-[#003463] line-clamp-2">
                    {service.title}
                </h3>
                <div className="mt-6">
                    <Link
                        to={`/service/${service.id}`}
                        className="mt-6 rounded-full border-2 border-[#07B2EC] px-5 py-2 text-sm font-semibold text-[#07B2EC] "
                    >
                        Дэлгэрэнгүй
                    </Link>
                </div>
            </div>
        ))}
    </Slider>
}
</div> */}